import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  TCreateCheckCorrectionRequest,
  TCreateCheckCorrectionResponse,
} from "./checkCorrections.schema";

export const createCheckCorrection =
  (axios: IAxiosInstance) => async (body: TCreateCheckCorrectionRequest) => {
    try {
      const response = await axios.noRetry.post<TCreateCheckCorrectionResponse>(
        "/api/checkCorrections",
        body
      );
      const resData = response.data;

      if (resData.success) {
        return resData.data;
      }
      throw new Error("Something went wrong");
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
